import React from "react";
import TranslationContext from "./TranslationContext";
export var TranslationProvider = function (_a) {
    var t = _a.t, children = _a.children;
    return (React.createElement(TranslationContext.Provider, { value: t }, children));
};
